// extracted by mini-css-extract-plugin
module.exports = {"appleButton":"appleSigninButton_appleButton__xWMqx"};